<template>
  <aw-spring :desktop-size="10">
    <aw-breadcrumb-version2 :class="$style.breadcrumb" />
    <aw-cms-white-card
      :class="$style.card"
      mobile-negative-margin
    >
      <template #head>
        <lv-heading
          level="1"
          tag="h1"
          version2
        >
          {{ $awt('aw.pages.csr.title') }}
        </lv-heading>
      </template>
      <aw-aggregated-page-highlighted-carousel page-type="csr" />
      <div :class="$style.headingWrapper">
        <lv-heading
          level="3"
          tag="h2"
          version2
        >
          {{ $awt('aw.pages.csr.introduction.title') }}
        </lv-heading>
      </div>
      <section v-html="$awt('aw.pages.csr.introduction.content')" />
      <aw-csr-tabs />
      <aw-separator />
      <aw-aggregated-page-tabs :params="{}" page-type="csr" />
    </aw-cms-white-card>
  </aw-spring>
</template>

<script setup lang="ts">
  import { onMounted, provide } from 'vue';
  import { useNuxtApp } from 'nuxt/app';
  import { useBreadcrumbStore } from '~~/common/stores/breadcrumb.js';
  import { LvHeading } from '~~/common/components/loginet-vue-shop/index';
  import AwCsrTabs from '~~/shop/app/components/Page/sustainability/AwCsrTabs.vue';
  import AwCmsWhiteCard from '~~/common/components/AwCmsWhiteCard.vue';
  import AwSeparator from '~~/common/components/Common/AwSeparator.vue';
  import AwBreadcrumbVersion2 from '~~/common/components/Common/AwBreadcrumbVersion2.vue';
  import AwSpring from '~~/common/components/AwSpring.vue';
  import AwAggregatedPageTabs from '~~/shop/app/components/Common/AggregatedPages/AwAggregatedPageTabs.vue';
  import AwAggregatedPageHighlightedCarousel from '~~/shop/app/components/Common/AggregatedPages/AwAggregatedPageHighlightedCarousel.vue';

  defineOptions({
    name: 'CsrPage',
  });
  // eslint-disable-next-line no-undef
  definePageMeta({
    layout: 'full-width',
  });

  const { $awt } = useNuxtApp();
  provide('getRowIndexById', () => 0);

  onMounted(() => {
    const breadcrumbStore = useBreadcrumbStore();

    breadcrumbStore.setBreadcrumbs([
      {
        token: $awt('aw.common.category.home'),
        to: '/',
        disabled: false,
      },
      {
        token: $awt('aw.pages.csr.title'),
        to: '/csr',
        disabled: true,
      },
    ]);
  });
</script>

<style module lang="scss" rel="stylesheet/scss">
.head {
  display: flex;
  flex-direction: column;

  @include tablet(min) {
    flex-direction: row;
    justify-content: space-between;
  }

  &Search {
    width: 100%;
    @include tablet(min) {
      width: 50%;
      max-width: 520px;
    }
  }
}

.headingWrapper {
  display: flex;
  justify-content: center;
  width: 100%;
  margin-bottom: 20px;
}

.breadcrumb {
  margin-bottom: 20px;
  @include tablet(min) {
    margin-bottom: 40px;
  }
}

.card {
  margin-bottom: 20px;
  @include tablet(min) {
    margin-bottom: 40px;
  }
}
</style>
